import { Body, closeDialog, Dialog, Footer, Header, openDialog } from '@/dialogs';
import useInDialog from '@/dialogs/hooks/useInDialog';
import tada from '@/shared/feedback/assets/confetti.svg';
import Button from '@/shared/ui/Button';

export const G2_REVIEW_DIALOG = 'G2_REVIEW_DIALOG';

export const openG2ReviewDialog = openDialog.bind(null, G2_REVIEW_DIALOG);
export const closeG2ReviewDialog = closeDialog.bind(null, G2_REVIEW_DIALOG);

interface G2ReviewDialogProps {
  nextAction?: () => void;
}

export default function G2ReviewDialog({ nextAction }: G2ReviewDialogProps) {
  const dialog = useInDialog();

  const handleClaim = () => {
    window.open(CONFIG.MARKETING_LINKS.G2_REVIEW_URL, '_blank', 'noopener,noreferrer');
    dialog.close();
    nextAction?.();
  };

  const handleClose = () => {
    dialog.close();
    nextAction?.();
  };

  return (
    <Dialog className="g2-review-dialog" width={500}>
      <Header onClose={handleClose}>Share the love</Header>
      <Body>
        <div className="g2-review-dialog__content">
          <h2>Get a $25 gift card!</h2>
          <img src={tada} alt="" />
          <p>Spread the word! Leave a review about how much you love When I Work and we'll send you a thank you.</p>
        </div>
      </Body>
      <Footer>
        <Button className="pull-right" color="primary" onClick={handleClaim}>
          Claim my $25
        </Button>
      </Footer>
    </Dialog>
  );
}
